import React from 'react';
export function UrgencyBar() {
  return <div className="bg-gold text-base text-center py-2.5 px-4 text-[13px] font-extrabold tracking-wide" data-id="element-205">
      ⚠️ PRECIO DE LANZAMIENTO — Solo por tiempo limitado. Después sube.
    </div>;
}